const phases = [
  {
    id: "p1",
    label: "Phase 01",
    status: "Active",
    title: "Vibecast Studio.",
    body: [
      "Ship Vibecast Studio to verified tech professionals.",
      "Onboard the first cohort of engineering and design creators to partner with us and build content.",
    ],
  },
  {
    id: "p2",
    label: "Phase 02",
    status: "In Progress",
    title: "Public beta + Vibecast mobile app.",
    body: [
      "Expand access, launch mobile experiences and grow the professional creator and viewer network.",
      "Introduce stronger content discovery, professional profiles, playlists and learning-oriented engagement.",
    ],
  },
  {
    id: "p3",
    label: "Phase 03",
    status: "Next",
    title: "Professional platform — the full Laiv AI stack.",
    body: [
      "Expand Vibecast into a professional media ecosystem with creator tools, monetization, analytics and intelligent discovery.",
      "The objective is no longer simply to host videos. It is to build the network connecting professional knowledge creators with professionals who want to learn.",
    ],
  },
];

export const Roadmap = () => {
  return (
    <section
      id="vision"
      data-testid="roadmap-section"
      className="relative py-12 sm:py-16 border-t border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-4">
            <div className="sticky top-28">
              <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#0066FF]">
                Vision & Roadmap
              </p>
              <h2 className="font-display mt-5 text-4xl sm:text-5xl font-bold tracking-[-0.02em] text-zinc-950 leading-[1.05]">
                A focused path. Every phase compounds.
              </h2>
              <p className="mt-5 text-zinc-600 font-light leading-relaxed">
                We don&apos;t ship features — we ship a sequence of products where
                each one unlocks the next.
              </p>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-8 lg:pl-10">
            <div className="relative">
              <div className="absolute left-[11px] top-2 bottom-2 w-px bg-black/10" />

              <div className="space-y-10">
                {phases.map((p, i) => (
                  <div
                    key={p.id}
                    data-testid={`roadmap-${p.id}`}
                    className="group relative pl-12"
                  >
                    <span
                      className={`absolute left-0 top-1.5 w-6 h-6 rounded-full grid place-items-center ${
                        i === 0
                          ? "bg-[#0066FF] text-white shadow-[0_0_24px_rgba(0,102,255,0.6)]"
                          : "bg-white border border-black/15 text-zinc-600"
                      } group-hover:bg-[#0066FF] group-hover:text-white group-hover:shadow-[0_0_24px_rgba(0,102,255,0.5)] transition-all duration-300`}
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-current" />
                    </span>

                    <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] font-semibold">
                      <span className="text-zinc-950">{p.label}</span>
                      <span className="px-2 py-0.5 rounded-full border border-black/10 text-zinc-600 bg-white">
                        {p.status}
                      </span>
                    </div>
                    <h3 className="font-display mt-3 text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-950 leading-snug">
                      {p.title}
                    </h3>
                    <div className="mt-3 space-y-2 text-zinc-600 font-light leading-relaxed max-w-xl">
                      {p.body.map((para, idx) => (
                        <p key={idx}>{para}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
